"use client";

import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";

import { useAuth } from "@/context/AuthContext";
import { usePortal } from "@/context/PortalContext";

const ITEMS = {
  home: { label: "Home", tab: "latest" },
  "my-spaces": { label: "My Spaces", tab: "myhubs", requiresAuth: true },
  "explore-spaces": { label: "Explore Spaces", tab: "hubs" },
};

export default function PortalPrimaryNavigation() {
  const portal = usePortal();
  const { user } = useAuth();
  const pathname = usePathname();
  const search = useSearchParams();
  const activeTab = (search.get("t") || search.get("tab") || "latest").toLowerCase();

  if (!portal || portal.unavailable) return null;

  return (
    <nav aria-label={`${portal.name} navigation`} className="border-t border-white/10">
      <div className="portal-header-inner no-scrollbar flex items-center gap-1 overflow-x-auto py-1.5">
        {portal.navigation.topLevel.map((key) => {
          const item = ITEMS[key];
          if (!item) return null;
          const target = `/?t=${item.tab}`;
          const href = item.requiresAuth && !user
            ? `/login?redirect=${encodeURIComponent(target)}`
            : target;
          const active = pathname === "/" && activeTab === item.tab;
          return (
            <Link
              key={key}
              href={href}
              aria-current={active ? "page" : undefined}
              className={[
                "relative shrink-0 px-3 py-2 text-sm font-semibold text-white/70 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)]",
                active ? "text-white" : "",
              ].join(" ")}
            >
              {item.label}
              <span
                aria-hidden
                className={[
                  "absolute inset-x-3 bottom-0 h-0.5 rounded-full",
                  active ? "bg-[var(--brand)]" : "bg-transparent",
                ].join(" ")}
              />
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
